module.exports = __webpack_public_path__ + "static/media/18.9bf3e247.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/lhand/18.png
// module id = 758
// module chunks = 0